module.exports = __webpack_public_path__ + "assets/img/00002.ace2913f.png";